
import { defineComponent, ref, watch } from "vue";
import { useStore } from "vuex";
import { Display, FirestoreDocument, Account } from "../../types/types";
import DisplayItem from "../Controller/DisplayItem.vue";
import { getDisplayByDisplayID, updateDisplay } from "../../api/display";
import { updateAccount } from "../../api/account";
import TokenList from "./TokenList.vue";

export default defineComponent({
  components: { DisplayItem, TokenList },
  props: {
    createDisplay: {
      type: Function,
      required: true
    },
    display_id: {
      type: String,
      required: false
    }
  },
  setup(props, { emit }) {
    const display = ref<FirestoreDocument<Display>>({
      id: "",
      entity: { name: "" } as Display
    });
    const store = useStore();

    const handleSave = async () => {
      //props.createDisplay(props.account_id, name.value);
      await updateDisplay(display.value);
      emit("update:display_id", null);
    };
    const forgetDisplay = async () => {
      display.value.entity.account_id = "";
      display.value.entity.token_id = "";
      display.value.entity.asset_contract_address = "";
      await updateDisplay(display.value);
      emit("update:display_id", null);
    };

    const shareAndRemember = async () => {
      const account: FirestoreDocument<Account> = store.getters.account;
      if (
        props.display_id &&
        !account.entity.saved_display_ids.includes(props.display_id)
      ) {
        account.entity.saved_display_ids.push(props.display_id);
        await updateAccount(account);
      }

      display.value.entity.account_id = "";
      display.value.entity.token_id = "";
      display.value.entity.asset_contract_address = "";
      await updateDisplay(display.value);
      emit("update:display_id", null);
    };

    const openDisplayInBrowser = async () => {
      window.open(
        `${window.location.origin}${window.location.pathname}/#/display?display_id=${props.display_id}`
      );
    };

    watch(
      props,
      () => {
        if (props.display_id) {
          getDisplayByDisplayID(props.display_id).then(ret_display => {
            display.value = ret_display;
          });
        } else {
          display.value = { id: "", entity: { name: "" } as Display };
        }
      },
      { immediate: true }
    );

    /*  const selected_token_id_pair = computed(
      (): TokenIDPair => {
        return {
          token_id: display.value.entity.token_id,
          asset_contract_address: display.value.entity.asset_contract_address
        };
      }
    ); */
    /* const demo_token_playlist = computed({
      get(): boolean {
        if (!display.value.entity.playlist_tokens) {
          return false;
        }
        return display.value.entity.playlist_tokens.length > 0;
      },
      set(v): void {
        if (v) {
          display.value.entity.playlist_tokens = store.getters.demo_tokens.map(
            (t: OpenseaToken) => ({
              asset_contract_address: t?.asset_contract?.address,
              token_id: t.token_id
            })
          );
        } else {
          display.value.entity.playlist_tokens = [];
        }
      }
    }); */

    /* watch(selected_token_id_pair, id_pair => {
      if (!id_pair) {
        display.value.entity.asset_contract_address = "";
        return;
      }
      const token = store.getters.demo_token_meta(id_pair.asset_contract_address, id_pair.token_id);
      // token may be null the display is set to the token the user does not have
      if (!token) {
        console.log("TOKEN NOT FOUND FOR token_id = ", id_pair);
        return;
      }
      display.value.entity.asset_contract_address =
        token.asset_contract.address;
    }); */

    return {
      handleSave,
      forgetDisplay,
      shareAndRemember,
      display,
      openDisplayInBrowser
      //demo_token_playlist
    };
  }
});
